import { render, staticRenderFns } from "./ImportBirthday.vue?vue&type=template&id=96d5a8c2&scoped=true&"
import script from "./ImportBirthday.vue?vue&type=script&lang=js&"
export * from "./ImportBirthday.vue?vue&type=script&lang=js&"
import style0 from "./ImportBirthday.vue?vue&type=style&index=0&id=96d5a8c2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96d5a8c2",
  null
  
)

export default component.exports